import { useState, useRef, useEffect } from 'react';

const STEP_OPTIONS = [
  { type: 'email', label: 'Email', icon: 'M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z' },
  { type: 'wait', label: 'Wait', icon: 'M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z' },
  { type: 'condition', label: 'Condition', icon: 'M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z' },
  { type: 'exit', label: 'Exit', icon: 'M5 13l4 4L19 7' },
];

export default function AddStepButton({ onAdd }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    }
    if (open) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  return (
    <div className="relative flex justify-center" ref={ref}>
      <button
        onClick={() => setOpen(!open)}
        className="w-6 h-6 rounded-full border-2 border-dashed border-ink/40 hover:border-primary hover:text-primary text-ink/40 flex items-center justify-center text-sm transition-all duration-200 hover:scale-110"
      >
        +
      </button>

      {open && (
        <div className="absolute top-8 z-20 bg-surface border-2 border-ink rounded-xl shadow-brutal py-1 w-36">
          {STEP_OPTIONS.map(opt => (
            <button
              key={opt.type}
              onClick={() => { onAdd(opt.type); setOpen(false); }}
              className="w-full flex items-center gap-2 px-3 py-2 text-sm font-medium text-text-primary hover:bg-primary/10 transition-colors"
            >
              <svg className="w-4 h-4 text-text-secondary" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d={opt.icon} />
              </svg>
              {opt.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
